export const ltcIconsContent = new Map<string, string>();

const requestsCache = new Map<string, Promise<Response>>();

export async function loadSvgContent(url: string): Promise<Response | undefined> {
  if (typeof fetch !== 'undefined' && typeof document !== 'undefined') {
    // Check if the URL is already in the cache
    if (requestsCache.has(url)) {
      return requestsCache.get(url);
    }

    // If the URL is not in the cache, fetch it and add the promise to the cache
    const promise = fetch(url).then(async (response) => {
      if (response.ok) {
        const svgContent = await response.text();
        ltcIconsContent.set(url, svgContent || '');
      } else {
        ltcIconsContent.set(url, '');
      }
      return response;
    });

    requestsCache.set(url, promise);
    return promise;
  }

  // set to empty for ssr scenarios and resolve promise
  ltcIconsContent.set(url, '');
}
